import { render, staticRenderFns } from "./HotHallList.vue?vue&type=template&id=03dfd52e&scoped=true"
import script from "./HotHallList.vue?vue&type=script&lang=js"
export * from "./HotHallList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dfd52e",
  null
  
)

export default component.exports